"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

var _Formio = _interopRequireDefault(require("../../Formio"));

var _lodash = _interopRequireDefault(require("lodash"));

var _utils = require("../../utils/utils");

var _WithCKEditor2 = _interopRequireDefault(require("../../utils/WithCKEditor"));

var _TextField = _interopRequireDefault(require("../textfield/TextField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var defaultValues = {
  minHeight: 200,
  maxHeight: 500
};

var TextAreaComponent =
/*#__PURE__*/
function (_WithCKEditor) {
  _inherits(TextAreaComponent, _WithCKEditor);

  _createClass(TextAreaComponent, null, [{
    key: "schema",
    value: function schema() {
      for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
        extend[_key] = arguments[_key];
      }

      return _TextField.default.schema.apply(_TextField.default, [{
        type: 'textarea',
        label: 'Text Area',
        key: 'textArea',
        rows: 3,
        wysiwyg: false,
        editor: ''
      }].concat(extend));
    }
  }, {
    key: "builderInfo",
    get: function get() {
      return {
        title: 'Text Area',
        group: 'basic',
        icon: 'fa fa-font',
        documentation: 'http://help.form.io/userguide/#textarea',
        weight: 40,
        schema: TextAreaComponent.schema()
      };
    }
  }]);

  function TextAreaComponent(component, options, data) {
    var _this2;

    _classCallCheck(this, TextAreaComponent);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TextAreaComponent).call(this, component, options, data));
    _this2.wysiwygRendered = false; // Never submit on enter for text areas.

    _this2.options.submitOnEnter = false;
    return _this2;
  } // добавил spacesInsteadTags - булевый параметр, который заменяет теги на пробелы


  _createClass(TextAreaComponent, [{
    key: "removeTags",
    value: function removeTags(value, spacesInsteadTags) {
      var removeEditorBlank = function removeEditorBlank(input) {
        if (typeof input !== 'string') {
          return input;
        } // необходимо для корректного подсчета слов


        var replaceValue = spacesInsteadTags ? ' ' : '';
        input = input.replace(/<(.*?)>/g, replaceValue);
        return input.replace(/&nbsp;/g, ' ');
      };

      if (Array.isArray(value)) {
        value.forEach(function (input, index) {
          value[index] = removeEditorBlank(input);
        });
      } else {
        value = removeEditorBlank(value);
      }

      return value;
    }
  }, {
    key: "show",
    value: function show(_show, noClear) {
      if (_show && !this.wysiwygRendered) {
        this.enableWysiwyg();
        this.setWysiwygValue(this.dataValue);
        this.wysiwygRendered = true;
      } else if (!_show && this.wysiwygRendered) {
        this.destroyWysiwyg();
        this.wysiwygRendered = false;
      }

      return _get(_getPrototypeOf(TextAreaComponent.prototype), "show", this).call(this, _show, noClear);
    } // переопределение build из Base
    // тут убирается проверка на viewOnly и создается textarea как в режиме редактирования
    // это нужно для правильного отображения содержимого в редакторе
    // в режиме viewOnly редакторы будут disabled

  }, {
    key: "build",
    value: function build(state) {
      this.wysiwygRendered = false;
      state = state || {};
      this.calculatedValue = state.calculatedValue;
      this.createElement();
      var labelAtTheBottom = this.component.labelPosition === 'bottom';

      if (!labelAtTheBottom) {
        this.createLabel(this.element);
      }

      if (!this.createWrapper()) {
        this.createInput(this.element);
      }

      if (labelAtTheBottom) {
        this.createLabel(this.element);
      }

      this.createDescription(this.element); // Disable if needed.

      if (this.shouldDisable || this.viewOnly) {
        this.disabled = true;
      } // Restore the value.


      this.restoreValue(); // Attach the refresh on events.

      this.attachRefreshOn();
      this.autofocus();
      this.attachLogic(); // set height values

      if (this.inputs[0]) {
        var minHeightValue = this.component.minHeight;
        var minHeight = minHeightValue ? minHeightValue : defaultValues.minHeight;
        this.component.fieldHeightOld = minHeight + 'px';
        this.inputs[0].setAttribute('style', "min-height: ".concat(minHeight, "px; height: ").concat(minHeight, "px"));
      }
    } // eslint-disable-next-line max-statements

  }, {
    key: "onChange",
    value: function onChange(flags, fromRoot) {
      _get(_getPrototypeOf(TextAreaComponent.prototype), "onChange", this).call(this, flags, fromRoot); // textarea autoresize


      if (this.inputs[0] && !this.component.isWasManualResize) {
        var inputElement = this.inputs[0];
        this.component.fieldHeightNew = inputElement.style.height;
        var fieldHeightNew = this.component.fieldHeightNew;
        var fieldHeightOld = this.component.fieldHeightOld;

        if (fieldHeightNew !== fieldHeightOld) {
          this.component.isWasManualResize = true;
        }

        if (!this.component.isWasManualResize) {
          var maxHeightValue = this.component.maxHeight;
          var maxHeight = maxHeightValue ? maxHeightValue : defaultValues.maxHeight;
          inputElement.style.height = 0 + 'px';
          var scrollHeight = inputElement.scrollHeight;
          var topBorderWidth = getComputedStyle(inputElement).borderTopWidth;
          var bottomBorderWidth = getComputedStyle(inputElement).borderBottomWidth;
          var bordersWidth = parseInt(topBorderWidth) + parseInt(bottomBorderWidth);
          var newHeight = scrollHeight + bordersWidth;
          newHeight = newHeight > maxHeight ? maxHeight : newHeight;
          inputElement.style.height = newHeight + 'px';
          this.component.fieldHeightOld = inputElement.style.height;
        }
      }

      if (this.wordCount) {
        var value = this.component.editor ? this.removeTags(this.dataValue, true) : this.dataValue;
        var clearValue = value.trim();
        var wordCount = !!clearValue ? clearValue.split(/\s+/).length : 0;
        var wordCounterName = 'words';
        this.setCounter(wordCounterName, this.wordCount, wordCount, this.maxWordCount);
      }

      if (this.charCount) {
        var _value = this.component.editor ? this.removeTags(this.dataValue) : this.dataValue;

        if (this.originalComponent.deleteSpaces) {
          _value = _value.replace(/\s/g, ''); // удаляем все пробелы
        }

        var charachterCount = _value.length;
        var charachterCounterName = 'characters';
        this.setCounter(charachterCounterName, this.charCount, charachterCount, this.maxCharCount);
      }
    }
  }, {
    key: "setupValueElement",
    value: function setupValueElement(element) {
      var value = this.getValue();
      value = this.isEmpty(value) ? this.defaultViewOnlyValue : this.getView(value);

      if (this.component.wysiwyg) {
        value = this.interpolate(value);
      }

      element.innerHTML = value;
    }
  }, {
    key: "acePlaceholder",
    value: function acePlaceholder() {
      if (!this.component.placeholder || !this.editor) {
        return;
      }

      var shouldShow = !this.editor.session.getValue().length;
      var node = this.editor.renderer.emptyMessageNode;

      if (!shouldShow && node) {
        this.editor.renderer.scroller.removeChild(this.editor.renderer.emptyMessageNode);
        this.editor.renderer.emptyMessageNode = null;
      } else if (shouldShow && !node) {
        node = this.editor.renderer.emptyMessageNode = this.ce('div');
        node.textContent = this.t(this.component.placeholder);
        node.className = 'ace_invisible ace_emptyMessage';
        node.style.padding = '0 9px';
        this.editor.renderer.scroller.appendChild(node);
      }
    }
  }, {
    key: "updateEditorValue",

    /**
     * Updates the editor value.
     *
     * @param newValue
     */
    value: function updateEditorValue(newValue) {
      newValue = this.getConvertedValue(this.removeBlanks(newValue));

      if (newValue !== this.dataValue && (!_lodash.default.isEmpty(newValue) || !_lodash.default.isEmpty(this.dataValue))) {
        this.updateValue({
          modified: !this.autoModified
        }, newValue);
      }

      this.autoModified = false;
    }
    /* eslint-disable max-statements */
    // поменял class для div в условии this.options.readOnly

  }, {
    key: "createInput",
    value: function createInput(container) {
      if (this.options.readOnly) {
        this.input = this.ce('div', {
          class: 'formio-component-textarea--disabled'
        });
        container.appendChild(this.input);
        return this.input;
      } else if (this.isPlain) {
        return _get(_getPrototypeOf(TextAreaComponent.prototype), "createInput", this).call(this, container);
      }

      if (this.htmlView) {
        this.input = this.ce('div', {
          class: 'well'
        });
        container.appendChild(this.input);
        return this.input;
      } // добавление errorContainer для вывода ошибок


      this.errorContainer = container; // Add the input.

      this.input = this.ce('div', {
        class: 'formio-wysiwyg-editor'
      });
      container.appendChild(this.input);
      this.addCounter(container);
      return this.input;
    }
    /* eslint-enable max-statements */

  }, {
    key: "enableWysiwyg",
    value: function enableWysiwyg() {
      var _this3 = this;

      // убрана проверка для readOnly, для настройки disable в самих редакторах
      if (this.isPlain || this.options.htmlView) {
        return;
      }

      if (this.component.editor === 'ace') {
        this.editorReady = _Formio.default.requireLibrary('ace', 'ace', 'https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.1/ace.js', true).then(function () {
          var mode = _this3.component.as || 'javascript';
          _this3.editor = ace.edit(_this3.input);

          _this3.editor.on('change', function () {
            return _this3.updateEditorValue(_this3.editor.getValue());
          });

          _this3.editor.getSession().setTabSize(2);

          _this3.editor.getSession().setMode("ace/mode/".concat(mode));

          _this3.editor.on('input', function () {
            return _this3.acePlaceholder();
          });

          setTimeout(function () {
            return _this3.acePlaceholder();
          }, 100);
          return _this3.editor;
        });
        return this.input;
      }

      if (this.component.editor === 'ckeditor') {
        this.editorReady = this.addCKE(this.input, this.component.wysiwyg, function (newValue) {
          return _this3.updateEditorValue(newValue);
        }).then(function (editor) {
          _this3.editor = editor;

          if (_this3.options.readOnly || _this3.component.disabled) {
            _this3.editor.isReadOnly = true;
          }

          var numRows = parseInt(_this3.component.rows, 10);

          if (_lodash.default.isFinite(numRows) && _lodash.default.has(editor, 'ui.view.editable.editableElement')) {
            // Default height is 21px with 10px margin + a 14px top margin.
            var editorHeight = numRows * 31 + 14;
            editor.ui.view.editable.editableElement.style.height = "".concat(editorHeight, "px");
          }

          return editor;
        });
        return this.input;
      } // Normalize the configurations.


      if (this.component.wysiwyg && this.component.wysiwyg.toolbarGroups) {
        console.warn('The WYSIWYG settings are configured for CKEditor. For this renderer, you will need to use configurations for the Quill Editor. See https://quilljs.com/docs/configuration for more information.');
        this.component.wysiwyg = this.wysiwygDefault;
        this.emit('componentEdit', this);
      }

      if (!this.component.wysiwyg || typeof this.component.wysiwyg === 'boolean') {
        this.component.wysiwyg = this.wysiwygDefault;
        this.emit('componentEdit', this);
      } // Add the quill editor.


      this.editorReady = this.addQuill(this.input, this.component.wysiwyg, function () {
        return _this3.updateEditorValue(_this3.quill.root.innerHTML);
      }).then(function (quill) {
        if (_this3.component.isUploadEnabled) {
          var _this = _this3;
          quill.getModule('toolbar').addHandler('image', function () {
            //we need initial 'this' because quill calls this method with its own context and we need some inner quill methods exposed in it
            //we also need current component instance as we use some fields and methods from it as well
            _this.imageHandler.call(_this, this);
          });
        }

        quill.root.spellcheck = _this3.component.spellcheck;

        if (_this3.options.readOnly || _this3.component.disabled) {
          quill.disable();
        }

        return quill;
      }).catch(function (err) {
        return console.warn(err);
      });
    }
  }, {
    key: "destroyWysiwyg",
    value: function destroyWysiwyg() {
      if (this.editor) {
        this.editor.destroy();
      }
    }
  }, {
    key: "imageHandler",
    value: function imageHandler(quillInstance) {
      var _this4 = this;

      var fileInput = quillInstance.container.querySelector('input.ql-image[type=file]');

      if (fileInput == null) {
        fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', 'image/*');
        fileInput.classList.add('ql-image');
        fileInput.addEventListener('change', function () {
          var files = fileInput.files;
          var range = quillInstance.quill.getSelection(true);

          if (!files || !files.length) {
            console.warn('No files selected');
            return;
          }

          quillInstance.quill.enable(false);
          var _this4$component = _this4.component,
              uploadStorage = _this4$component.uploadStorage,
              uploadUrl = _this4$component.uploadUrl,
              uploadOptions = _this4$component.uploadOptions,
              uploadDir = _this4$component.uploadDir;
          var requestData;

          _this4.root.formio.uploadFile(uploadStorage, files[0], (0, _utils.uniqueName)(files[0].name), uploadDir || '', //should pass empty string if undefined
          null, uploadUrl, uploadOptions).then(function (result) {
            requestData = result;
            return _this4.root.formio.downloadFile(result);
          }).then(function (result) {
            quillInstance.quill.enable(true);
            var Delta = Quill.import('delta');
            quillInstance.quill.updateContents(new Delta().retain(range.index).delete(range.length).insert({
              image: result.url
            }, {
              alt: JSON.stringify(requestData)
            }), Quill.sources.USER);
            fileInput.value = '';
          }).catch(function (error) {
            console.warn('Quill image upload failed');
            console.warn(error);
            quillInstance.quill.enable(true);
          });
        });
        quillInstance.container.appendChild(fileInput);
      }

      fileInput.click();
    }
  }, {
    key: "setWysiwygValue",
    value: function setWysiwygValue(value) {
      var _this5 = this;

      if (this.isPlain || this.options.readOnly || this.options.htmlView) {
        return;
      }

      if (this.editorReady) {
        this.editorReady.then(function (editor) {
          _this5.autoModified = true;

          if (_this5.component.editor === 'ace') {
            editor.setValue(_this5.setConvertedValue(value));
          } else if (_this5.component.editor === 'ckeditor') {
            editor.data.set(_this5.setConvertedValue(value));
          } else {
            if (_this5.component.isUploadEnabled) {
              _this5.setAsyncConvertedValue(value).then(function (result) {
                editor.setContents(editor.clipboard.convert(result));
              });
            } else {
              editor.setContents(editor.clipboard.convert(_this5.setConvertedValue(value)));
            }
          }
        });
      }
    }
  }, {
    key: "setConvertedValue",
    value: function setConvertedValue(value) {
      if (this.component.as && this.component.as === 'json' && value) {
        try {
          value = JSON.stringify(value, null, 2);
        } catch (err) {
          console.warn(err);
        }
      }

      if (!_lodash.default.isString(value)) {
        value = '';
      }

      return value;
    }
  }, {
    key: "setAsyncConvertedValue",
    value: function setAsyncConvertedValue(value) {
      if (this.component.as && this.component.as === 'json' && value) {
        try {
          value = JSON.stringify(value, null, 2);
        } catch (err) {
          console.warn(err);
        }
      }

      if (!_lodash.default.isString(value)) {
        value = '';
      }

      var htmlDoc = new DOMParser().parseFromString(value, 'text/html');
      var images = htmlDoc.getElementsByTagName('img');

      if (images.length) {
        return this.setImagesUrl(images).then(function () {
          value = htmlDoc.getElementsByTagName('body')[0].firstElementChild;
          return new XMLSerializer().serializeToString(value);
        });
      } else {
        return Promise.resolve(value);
      }
    }
  }, {
    key: "setImagesUrl",
    value: function setImagesUrl(images) {
      var _this6 = this;

      return Promise.all(_lodash.default.map(images, function (image) {
        var requestData;

        try {
          requestData = JSON.parse(image.getAttribute('alt'));
        } catch (error) {
          console.warn(error);
        }

        return _this6.root.formio.downloadFile(requestData).then(function (result) {
          image.setAttribute('src', result.url);
        });
      }));
    }
  }, {
    key: "removeBlanks",
    value: function removeBlanks(value) {
      if (!value) {
        return value;
      }

      var removeBlanks = function removeBlanks(input) {
        if (typeof input !== 'string') {
          return input;
        }

        return input.replace(/<p>&nbsp;<\/p>|<p><br><\/p>|<p><br>&nbsp;<\/p>/g, '');
      };

      if (Array.isArray(value)) {
        value.forEach(function (input, index) {
          value[index] = removeBlanks(input);
        });
      } else {
        value = removeBlanks(value);
      }

      return value;
    }
  }, {
    key: "hasChanged",
    value: function hasChanged(before, after) {
      return _get(_getPrototypeOf(TextAreaComponent.prototype), "hasChanged", this).call(this, this.removeBlanks(before), this.removeBlanks(after));
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(value) {
      return _get(_getPrototypeOf(TextAreaComponent.prototype), "isEmpty", this).call(this, this.removeBlanks(value));
    }
  }, {
    key: "setValue",
    value: function setValue(value, flags) {
      var _this7 = this;

      value = value || '';

      if (this.options.readOnly || this.htmlView) {
        // For readOnly, just view the contents.
        if (this.input) {
          if (Array.isArray(value)) {
            value = value.join('<br/><br/>');
          }

          this.input.innerHTML = this.interpolate(value);
        }

        this.dataValue = value;
        return;
      } else if (this.isPlain) {
        value = Array.isArray(value) ? value.map(function (val) {
          return _this7.setConvertedValue(val);
        }) : this.setConvertedValue(value);
        return _get(_getPrototypeOf(TextAreaComponent.prototype), "setValue", this).call(this, value, flags);
      } // Set the value when the editor is ready.


      this.dataValue = value;
      this.setWysiwygValue(value, flags);
      this.updateValue(flags);
    }
  }, {
    key: "getConvertedValue",
    value: function getConvertedValue(value) {
      if (this.component.as && this.component.as === 'json' && value) {
        try {
          value = JSON.parse(value);
        } catch (err) {
          console.warn(err);
        }
      }

      return value;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.editorReady) {
        this.editorReady.then(function (editor) {
          return editor.destroy();
        });
      }

      return _get(_getPrototypeOf(TextAreaComponent.prototype), "destroy", this).call(this);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      if (this.viewOnly || this.htmlView || this.options.readOnly) {
        return this.dataValue;
      }

      if (this.isPlain) {
        return this.getConvertedValue(_get(_getPrototypeOf(TextAreaComponent.prototype), "getValue", this).call(this));
      }

      return this.dataValue;
    }
  }, {
    key: "elementInfo",
    value: function elementInfo() {
      var info = _get(_getPrototypeOf(TextAreaComponent.prototype), "elementInfo", this).call(this);

      info.type = 'textarea';

      if (this.component.rows) {
        info.attr.rows = this.component.rows;
      }

      return info;
    }
  }, {
    key: "defaultSchema",
    get: function get() {
      return TextAreaComponent.schema();
    }
  }, {
    key: "isPlain",
    get: function get() {
      return !this.component.wysiwyg && !this.component.editor;
    }
  }, {
    key: "htmlView",
    get: function get() {
      return this.options.readOnly && this.component.wysiwyg;
    }
  }, {
    key: "defaultValue",
    get: function get() {
      var defaultValue = _get(_getPrototypeOf(TextAreaComponent.prototype), "defaultValue", this);

      if (this.component.wysiwyg && !defaultValue) {
        defaultValue = '<p><br></p>';
      }

      return defaultValue;
    }
  }]);

  return TextAreaComponent;
}((0, _WithCKEditor2.default)(_TextField.default));

exports.default = TextAreaComponent;
TextAreaComponent.prototype.setCounter = _TextField.default.prototype.setCounter;